import { ParkingaboProductListItem } from '../../../shared/ParkingaboProductModels.ts';
import {
    ProductDetailBody,
    ProductOverviewList,
} from './ProductsDetailOutlet.tsx';
import { ParkingaboProductType } from 'product-shared/product-template/ParkingaboProductType.ts';

export function ProductDetailPermit({
    product,
}: {
    product: ParkingaboProductListItem;
}) {
    if (
        product.type !== ParkingaboProductType.PERMIT_UNTIL_REVOCATION &&
        product.type !== ParkingaboProductType.PERMIT_FREE_FIXED_DURATION &&
        product.type !== ParkingaboProductType.PERMIT_FREE_VALID_TO
    ) {
        throw new Error('product type must be of type permit');
    }

    return (
        <ProductDetailBody>
            <ProductOverviewList product={product} />
        </ProductDetailBody>
    );
}
